import { render, staticRenderFns } from "./DialogCreateQuickResponse.vue?vue&type=template&id=3b4ecc8d&scoped=true"
import script from "./DialogCreateQuickResponse.vue?vue&type=script&lang=js"
export * from "./DialogCreateQuickResponse.vue?vue&type=script&lang=js"
import style0 from "./DialogCreateQuickResponse.vue?vue&type=style&index=0&id=3b4ecc8d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4ecc8d",
  null
  
)

export default component.exports